import Flickity from 'flickity';
window.Flickity = Flickity;
